var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"controls-tree"},[(_vm.linear)?_c('ControlsTreeLinear',{attrs:{"path":_vm.path,"controls":_vm.controls}}):_c('ControlsTreeExpansionPanels',{attrs:{"forceFirstSectionOpen":_vm.forceFirstSectionOpen,"path":_vm.path,"controls":_vm.controls,"allowPopoutsInRoot":_vm.allowPopoutsInRoot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }